import { AsCardFragment } from "types/graphql-types";
import { LinkCardProps } from "./LinkCard";

export const fromAsCard = (
  card: AsCardFragment
): Omit<LinkCardProps, "action"> => {
  const title = card?.title?.localized;

  return {
    image: card?.image,
    title,
    description: card?.description?.localized,
    imageAltText: card?.image?.alt?.localized || title,
    trackingName: card?.trackingName?.en
  };
};
